import { Grid } from "@mui/material";
import { useMessage } from "hooks/intl";
import { isUndefined } from "lodash";
import { SegmentData } from "types/segments";
import { useStyles } from "./SingleSegment.styles";

export const BasicSettings = ({
  segmentData,
}: {
  segmentData?: SegmentData;
}) => {
  const classes = useStyles();
  const { message } = useMessage();

  const isStaticSegment = segmentData?.parts[0]?.criteria?.some(
    (criterion) => criterion.type === "customer_csv_list",
  );

  const segmentBasicSettings = [
    {
      left: "segmentType",
      leftDataTestId: "segment-type-label",
      right: message({
        id: isStaticSegment ? "staticSegment" : "dynamicSegment",
      }),
      rightDataTestId: "segment-type-value",
    },
    {
      left: "segmentName",
      leftDataTestId: "segment-name-label",
      right: segmentData?.name,
      rightDataTestId: "segment-name-value",
    },
    {
      left: "segmentDescription",
      leftDataTestId: "segment-description-label",
      right: segmentData?.description,
      rightDataTestId: "segment-description-value",
    },
  ];

  return (
    <Grid container className={classes.settingsContainer}>
      <Grid className={classes.gridChild} item xs={12}>
        <span className={classes.header}>
          {message({ id: "basicSettings" })}
        </span>
        {segmentBasicSettings.map((row) => (
          <span className={classes.content} key={row.left}>
            <span className={classes.left} data-test-id={row.leftDataTestId}>
              {message({ id: row.left })}
            </span>
            <span className={classes.right} data-test-id={row.rightDataTestId}>
              {isUndefined(row.right) ? "-" : row.right}
            </span>
          </span>
        ))}
      </Grid>
    </Grid>
  );
};
